import { InspectionPanel } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const InspectionPanelIcon = createLucideIcon(InspectionPanel);
